import { DatePipe, JsonPipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy, inject, input } from '@angular/core';
import { OrderHistoryObject, OrderItem } from 'app/Services/gestion.service';
import { QdmService, ServiceItem } from 'app/Services/qdm.service';
import { PipeNumberFormat } from '../Pipes/PipeNumberFormat';
import { AuthService, User, UserChildren } from 'app/Services/auth.service';
import { EnvLoader } from 'app/Environment/EnvLoader';
import { ModalService } from 'app/Services/modal.service';
import { ModalCommandsHistoryComponent } from '../Modal/ModalCommandsHistory/ModalCommandsHistory.component';
import { ChildSelectorComponent } from '../ChildSelector/child-selector.component';
import { CartService } from 'app/Cart/CartService';

@Component({
    selector: 'app-order-visualizer',
    template: `
    @if (this.viewOrder) {
      <div class="w-full h-full">
        <div class="h-full flex-1 overflow-y-auto p-4 pb-24">
          <div
            class="shadow flex items-center p-4 mb-4 text-sm text-yellow-800 border border-yellow-300 rounded-lg bg-yellow-50 max-w-[600px] mx-auto"
            role="alert"
            >
            <svg
              aria-hidden="true"
              class="flex-shrink-0 inline w-4 h-4 me-3"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
              >
              <path
                d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z"
                />
              </svg>
              <span class="sr-only">Info</span>
              <div>
                <span class="font-semibold">Commande déjà passée !</span> Vous avez
                déjà commandé pour ce jour.
              </div>
            </div>
            @if (this.user()?.children?.length) {
              <div
                class="max-w-80 w-fit mx-auto mb-4 p-2 rounded bg-white border border-gris-3 shadow-md"
                >
                <app-child-selector
                  class="block w-full"
                  (childSelected)="this.childSelected($event)"
                  />
                </div>
              }
              <button
                (click)="this.openCommandHistory(this.viewOrder)"
                class="shadow-md flex items-center gap-2 px-2 text-white bg-vert-1 rounded py-2 mx-auto mb-4 border border-vert-1 hover:bg-white transition hover:fg-noir-2"
                >
                <svg
                  class="size-6"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.5"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                  >
                  <path
                    d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897l8.932-8.931Zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    />
                  </svg>
                  <span class="font-semibold"> Gérer votre commande </span>
                </button>
                <div
                  class="mx-auto max-w-[600px] bg-white rounded w-full border border-vert-2 p-4 mb-4 fg-noir-2 font-medium shadow-md"
                  >
                  <p class="w-full font-semibold text-center mb-4 border-b border-gris-3 pb-3">
                    Récapitulatif de la commande
                  </p>
                  <p class="w-full fg-vert-1">
                    <span class="fg-noir-2">Date de commande: </span
                      >{{ this.viewOrder.deliveryDate | date : 'dd/MM/yyyy' }}
                    </p>
                    <p class="w-full fg-vert-1">
                      <span class="fg-noir-2">Moment repas: </span
                        >{{ this.viewOrder.mealmoment.name }}
                      </p>
                      <p class="w-full fg-vert-1">
                        <span class="fg-noir-2">Lieu de consommation: </span
                          >{{ this.viewOrder.enterprise.name }}
                        </p>
                        <p class="w-full fg-vert-1">
                          <span class="fg-noir-2">Menu / Click & Collect: </span
                            >{{
                            (this.viewOrder.companyMenuOption &&
                            this.viewOrder.companyMenuOption.label) ||
                            'Click & Collect'
                            }}
                          </p>
                          @if (this.isAcceptPayment()) {
                            <p class="w-full fg-vert-1">
                              <span class="fg-noir-2">Montant TTC: </span
                                >{{ (this.viewOrder.price | formatNumber) + '€' }}
                              </p>
                            }
                            @if (this.isAcceptPayment()) {
                              <p class="w-full fg-vert-1">
                                <span class="fg-noir-2">Dont TVA: </span
                                  >{{
                                  (this.viewOrder.price - this.viewOrder.priceWithoutVat
                                  | formatNumber) + '€'
                                  }}
                                </p>
                              }
                              <p class="w-full fg-vert-1">
                                <span class="fg-noir-2">Convive: </span>
                                <span class="capitalize">{{
                                  this.viewOrder.child_name ||
                                  this.user()?.firstname + ' ' + this.user()?.lastname
                                }}</span>
                              </p>
                              @if (this.viewOrder.comment && this.viewOrder.comment.trim().length > 0) {
                                <p class="w-full fg-vert-1">
                                  <span class="fg-noir-2">Commentaire: </span>{{ this.viewOrder.comment }}
                                </p>
                              }
                            </div>
                            <div
                              class="mx-auto max-w-[600px] bg-white rounded w-full border border-vert-2 p-4 fg-noir-2 shadow-md"
                              >
                              <p class="w-full font-semibold text-center mb-4 border-b border-gris-3 pb-3">
                                Contenu de la commande
                              </p>
                              @for (item of this.viewOrder.orderItems; track item) {
                                <div
                                  class="w-full flex items-center gap-2 py-2 border-b border-gris-3"
                                  >
                                  <div class="w-12 h-12 relative p-2" >
                                    <img
                  [attr.src]="
                    this.QDM_URL +
                    '/upload/course_images/' +
                    (this.viewOrder.company.reference || 0) +
                    '/image_' +
                    item.platId
                  "
                                      (error)="onImageError($event, item)"
                                      class="w-full h-full object-contains rounded"
                                      onerror="this.src = '/assets/images/plats/default_image_menu.webp';"
                                      />
                                    </div>
                                    <div class="flex-1">
                                      <p class="font-medium">
                                        <span class="font-bold">{{ item.quantity + 'x' }}</span>
                                        {{ item.serviceContent }}
                                      </p>
                                      @if (this.isAcceptPayment()) {
                                        <p
                                          class="text-sm fg-vert-1 font-medium"
                                          >
                                          {{ (item.price || 0 | formatNumber) + '€' }}
                                        </p>
                                      }
                                    </div>
                                  </div>
                                }
                              </div>
                            </div>
                          </div>
                        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DatePipe, PipeNumberFormat, ChildSelectorComponent]
})
export class OrderVisualizerComponent implements OnChanges, OnInit {
  private cdr = inject(ChangeDetectorRef);
  private modal = inject(ModalService);
  private cart = inject(CartService);
  private qdm = inject(QdmService);
  private auth = inject(AuthService);

  readonly orders = input<OrderHistoryObject[]>();
  readonly currentService = input<ServiceItem>();

  readonly user = input<User>();
  readonly isAcceptPayment = input<boolean>(false);

  viewOrder: OrderHistoryObject | undefined = undefined;

  QDM_URL: string = '';

  ngOnInit(): void {
    this.QDM_URL = EnvLoader.load().qdmApiUrl;
    this.loadCurrentOrder();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['orders'] || changes['currentService']) {
      this.loadCurrentOrder();
    }
  }

  loadCurrentOrder() {
    const orders = this.orders();
    if (!orders || orders.length === 0) return;

    // Si un service est sélectionné, cherche la commande pour ce service
    if (this.currentService()) {
      const order = orders.find(
        (order) => order.svc_id === this.currentService()?.svc_id
      );
      if (order) {
        this.viewOrder = order;
        this.cdr.detectChanges();
        return;
      }
    }

    // Si aucun service n'est sélectionné ou aucune commande trouvée pour le service sélectionné,
    // affiche la première commande disponible
    this.viewOrder = orders[0];
    this.cdr.detectChanges();
  }

  openCommandHistory(order: OrderHistoryObject) {
    this.modal.open(
      ModalCommandsHistoryComponent,
      {
        orderToShow: order.id,
      },
      () => {}
    );
  }

  childSelected($child: UserChildren) {
    this.qdm.selectedChildSubject.next($child);
  }

  onImageError(event: Event, item: OrderItem) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = item.service?.image || '/assets/images/plats/default_image_menu.webp';
  }
}
